export function fromCurrency(currency: string) {
  return Number(currency.trim().replace(/[$,]/gi, ''))
}

export function toCurrency(input: number | string) {
  const n = typeof input === 'string' ? Number(input) : input
  return isNaN(n) ? '$0' : n.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 })
}

export function isCurrency(str: string) {
  return /^\$?[0-9]+(\.[0-9]{1,2})?$/.test(str)
}
